import { useDispatch } from 'react-redux';

import { apiSlice } from '../api/apiSlice';

export const useManualCache = () => {
  const dispatch = useDispatch();

  /**
   * invalidates rtk query cache manually, only use to avoid multiple updates, else add tags in the slice
   * @param {array} tags - tags array
   */
  const updateCache = tags => {
    dispatch(apiSlice.util.invalidateTags(tags));
  };

  return [updateCache];
};
